/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    Module
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { INavigationMenuViewProps } from './citta-custom-navigation-menu';

const NavigationMenuView: React.FC<INavigationMenuViewProps> = props => {
    const { Navigation, links } = props;
    if (!links) {
      return null;
    }
    return (
      <Module {...Navigation} className={classnames(Navigation.className, 'parent')}>
        {links}
      </Module>
    );
  };
  
  export default NavigationMenuView;
